// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"showMore_wrapper__3Hwi8"};